import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";
import { toastService } from "../../utils/toastify";
export const getPodcast = createAsyncThunk(
  "get/podcast",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("podcastList", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error);
    }
  }
);
export const getPodcastDetail = createAsyncThunk(
  "get/podcastDetail",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("podcastDetails", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error);
    }
  }
);
export const addPodcast = createAsyncThunk(
  "add/podcast",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("addPodcast", payload);
      return response.data;
    } catch (error) {
      console.log({ error });
       if (error?.response?.data?.code == 403) {
         toastService.error(error?.response?.data?.message);
         rejectWithValue(error);
       } else {
         toastService.error("Podcast added failed");
         rejectWithValue(error);
       }
    }
  }
);
export const editPodcast = createAsyncThunk(
  "edit/podcast",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put("editPodcast", payload);
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error);
    }
  }
);
export const podcastStatusChanged = createAsyncThunk(
  "statusChanged/podcast",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(
        "podcastStatusChanged",
        payload
      );
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error);
    }
  }
);
export const getEpiosde = createAsyncThunk(
  "get/epiosde",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("episodeList", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error);
    }
  }
);
export const addEpiosde = createAsyncThunk(
  "add/epiosde",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("addEpisode", payload);
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error);
    }
  }
);
export const editEpiosde = createAsyncThunk(
  "add/epiosde",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put("editEpisode", payload);
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error);
    }
  }
);
export const episodeStatusChanged = createAsyncThunk(
  "statusChanged/episode",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(
        "statusChangedEpisode",
        payload
      );
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error);
    }
  }
);
export const savePodcast = createAsyncThunk(
  "save/podcast",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("podcastSave", payload);
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error);
    }
  }
);
export const publishPodcast = createAsyncThunk(
  "publish/podcast",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("publishAllEpisode", payload);
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error);
    }
  }
);
export const discardPodcast = createAsyncThunk(
  "discard/podcast",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("discardAllEpisode", payload);
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error);
    }
  }
);
const podCast = createSlice({
  name: "podcast",
  initialState: {
    podcast: [],
    episode: [],
    podcastDetail: [],
    loading: false,
  },
  extraReducers: (builder) => {
    builder.addCase(getPodcast.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPodcast.fulfilled, (state, action) => {
      state.loading = false;
      state.podcast = action.payload;
    });
    builder.addCase(getPodcast.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(getEpiosde.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getEpiosde.fulfilled, (state, action) => {
      state.loading = false;
      state.episode = action.payload;
    });
    builder.addCase(getEpiosde.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(getPodcastDetail.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPodcastDetail.fulfilled, (state, action) => {
      state.loading = false;
      state.podcastDetail = action.payload;
    });
    builder.addCase(getPodcastDetail.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export default podCast.reducer;
